<template>
  <div class="brands-container">
    <div class="register-title-box">
      <span class="register-font">Brands</span>
      <span class="apply-font">브랜드</span>
    </div>

    <img src="https://s3.ap-northeast-2.amazonaws.com/greyd.web/compressed/collaborate.png" width="100%">
  </div>
</template>

<script>
export default {
  name: 'Brands',
  data () {
    return {}
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped src="@/assets/styles/brands.css"></style>
<style scoped src="@/assets/styles/brands-mobile.css"></style>



// WEBPACK FOOTER //
// src/components/renewal/components/Brands.vue